// NewsletterPage.js

import React, { useState } from 'react';
import './NewsLetter.css';

const NewsletterPage = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can implement your logic to submit the email
    console.log('Submitted email:', email);
    // Clear the input field after submission
    setEmail('');
  };

  return (
    <div className="newsletter-container">
      <h1>Subscribe to Our Newsletter</h1>
      <p>Stay updated with our latest news and promotions.</p>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Subscribe</button>
      </form>
    </div>
  );
};

export default NewsletterPage;
